import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=20e2dbdb"
import script from "./Impressum.vue?vue&type=script&setup=true&lang=ts"
export * from "./Impressum.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports